<div id="nav">
  <button class="flex f_align_c gap_10 nav-logo-container" (click)="api.userInfo ? navTo('dashboard') : navTo('/')">
    @if((api.userRole.isWorker || api.userRole.isAdmin)) {
      <img class="nav-logo" src="assets/bms-full.svg"/>
      <div [matTooltip]="'tooltip.syncing' | translate"
           class="sync-global cursor-pointer"
           (click)="queue.openExportDialog($event)"
           *ngIf="queue.queue.length && api.hasPerm(UserPermission.ALLOW_CONSUME) && api.userRole.isWorker">
        <app-paragraph class="fullWidth">{{('global.syncing' | translate) + ' (' + queue.queue.length + ')'}}</app-paragraph>
        <svg viewBox="0 0 50 50">
          <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5" style="stroke: black; stroke-opacity: 0.5;"/>
        </svg>
      </div>
    } @else {
      <img class="nav-logo" [src]="api.env.useGuichet ? api.env.theme.flag : 'assets/logo-full.png'"/>
    }
  </button>
  <div class="progress-container" *ngIf="!api.userRole.isKiosk">
    <pop-icon-button *ngIf="!api.env.contactSupportMailto" icon="question-circle" label="help" (click)="api.openSupport()" [matTooltip]="'tooltip.support' | translate"></pop-icon-button>

    <div class="progress-wrap f_col f_align_c f_center" *ngIf="api.userRole.isWorker || api.userRole.isAdmin">
      <fa-icon icon="wifi" class="network-icon"></fa-icon>
      <div class="progress-bar network-progress"
           [class.network-progress-online]="pingOnline === NetworkPingState.ONLINE"
           [class.network-progress-offline]="pingOnline === NetworkPingState.OFFLINE"></div>
    </div>
    <div class="progress-wrap f_col f_align_c f_center" [class.progress-wrap-hidden]="!progressDownloadValues.length">
      <fa-icon icon="download" class="download-icon"></fa-icon>
      <div class="progress-bar download-progress-bar" [class.show-pulse-progress]="progressDownloadValues.length && progressDownloadValues[0] < 1" [class.has-progress]="progressDownloadValues.length">
        <ng-container *ngFor="let download of progressDownloadValues" >
          <div class="progress download-progress" [style.width.%]="download"></div>
        </ng-container>
      </div>
    </div>
    <div class="progress-wrap f_col f_align_c f_center" [class.progress-wrap-hidden]="!progressUploadValues.length">
      <fa-icon icon="upload" class="upload-icon"></fa-icon>
      <div class="progress-bar upload-progress-bar" [class.show-pulse-progress]="progressUploadValues.length && progressUploadValues[0] < 1" [class.has-progress]="progressUploadValues.length">
        <ng-container *ngFor="let upload of progressUploadValues" >
          <div class="progress upload-progress" [style.width.%]="upload"></div>
        </ng-container>
      </div>
    </div>
    @if(api.processedSession && !api.userRole.isCustomer && !api.userRole.isKiosk)  {
      <div class="number-processed-wrapper">
        <div class="number-processed" tabindex="0">{{api.processedSession.total}}</div>
        <div class="details-container">
          <app-paragraph class="details-title" size="xl" [innerHtml]="'processed.title' | translate"></app-paragraph>
          <div *ngFor="let detail of api.processedSession.details" class="detail-item" [style.color]="detail.color">
            <app-paragraph>{{detail.count}}</app-paragraph>
            <app-paragraph>{{('DYN.processed.' + detail.operation) | translate}}</app-paragraph>
          </div>
          <div class="divider"></div>
          <div class="details-allCount">
            <app-paragraph>{{api.processedSession.total}}</app-paragraph>
            <app-paragraph>{{'total' | translate}}</app-paragraph>
          </div>
          <div class="divider divider-warn"></div>
          <div class="flex gap_5">
            <fa-icon size="xs" [icon]="'triangle-exclamation'" [ngStyle]="{'color': 'orange'}"></fa-icon>
            <app-paragraph class="details-sessionBased" [innerHtml]="'processed.sessionBased' | translate"></app-paragraph>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="flex gap_5">
    <div class="flex gap_5" *ngIf="(api.isElectronApp || !!api.devtoolFakePassport) && api.userRole.isWorker && api.hasPerm(api.perm.ALLOW_CONSUME) && !api.checkSeniority()">
      <app-menu [menuItems]="menuConsumeMode" [placeholder]="'scan.choice' | translate"  (selectionChange)="scanDocument.changeConsume($event)" [value]="scanDocument.consumeMode" rightIcon="chevron-down"></app-menu>
      <app-button *ngIf="!api.userRole?.isCustomer && scanDocument.consumeMode" color="secondary" size="xs" icon="passport" (btnClicked)="scanPassport()" [matTooltip]="'tooltip.scanPassport' | translate">{{'dropdown.pass' | translate}}</app-button>
      <app-divider *ngIf="!api.userRole?.isCustomer" orientation="vertical"></app-divider>
    </div>
    <div class="flex gap_5" *ngIf="!api.userRole?.isCustomer && !api.userRole?.isExternalMonitor && api.env.showSearchFromDocument">
      <app-button
      color="secondary"
      size="xs"
      icon="passport"
      (click)="scanDocument.scanMrzAndFilterRequests()">{{'nav.searchFromDocument' | translate}}</app-button>
      <app-divider *ngIf="!api.userRole?.isCustomer" orientation="vertical"></app-divider>
    </div>
    <app-button *ngIf="hasUiPerm(UiPermission.SHOW_QR_SCANNER_BTN)"
        color="secondary"
        size="xs"
        icon="qrcode"
        shortcut [shortcutFnList]="true" [shortcutStyle]="{bottom: '-13px', scale: 0.8}"
        (click)="clickScan()"
        [matTooltip]="'tooltip.Qr' | translate">{{'payments.scan' | translate}}</app-button>
    <ng-container *ngFor="let item of data">
      <div class="nav_item"
           *ngIf="item.guard && (item.perm ? api.hasPerm(item.perm) : true)"
           [matTooltip]="item?.tip ? (item.tip | translate) : ''">
          <app-button shortcut [shortcutFnList]="true" [shortcutStyle]="{bottom: '-13px', scale: 0.8}" [borderXs]="true" color="secondary" [class.bold]="item.route === router.url" size="xs" shortcut [shortcutFnList]="true" [shortcutStyle]="{bottom: '-13px', scale: 0.8}" (click)="item.route ? navTo(item.route) : item.action ? item.action() : undefined">{{item.label | translate}}</app-button>
      </div>
    </ng-container>
    <app-snackbar *ngIf="api.userInfo" class="cursor-pointer" (click)="navTo('my-account')" [matTooltip]="'tooltip.role' | translate">
      {{api.userInfo.name || api.userInfo.accountName + ((api.userInfo.role === UserPlatformRole.WORKER || api.userInfo.role === UserPlatformRole.ADMIN) ? (' | ' + (('form.role.'+userRoles[api.userInfo.role] | lowercase) | translate)) : '')}}
    </app-snackbar>
  </div>
</div>
